// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import * as React from 'react';
import { bindHandler } from '../../utils';
import { useObserver } from "../../utils/ObserverHooks";
import * as Styles from './PillNavigatorWidget.scss';
export default function PillNavigatorWidget(props) {
    var _a, _b;
    const { iconButton, header, items } = props.data;
    const iconButtonElement = useObserver(iconButton);
    useStyles(Styles);
    return (React.createElement("div", { className: Styles.pillNavigator },
        React.createElement("h4", null, header),
        React.createElement("div", null,
            iconButtonElement &&
                React.createElement("music-button", { id: "pillNavigatorIconButton", "icon-name": (_a = iconButtonElement) === null || _a === void 0 ? void 0 : _a.icon, "icon-only": true, variant: "glass", size: "small", onClick: bindHandler(props.handleSelected, null, (_b = iconButtonElement) === null || _b === void 0 ? void 0 : _b.onItemSelected) }),
            items.map((item, index) => (React.createElement("music-pill-item", { id: `pillNavigatorButton${index + 1}`, text: item.text, onClick: bindHandler(props.handleSelected, null, item.onItemSelected) }, item.text))))));
}
;
